export default "__VITE_ASSET__BFBi8$$V__"